import { gsap, Power2 } from "gsap";

import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Header from '../layout/Header';
import NoScroll from './NoScroll';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { ScrollMachine } from "./Projects";

export default class Gallery extends NoScroll {
  sliderDom;
  scroller;

  constructor() {
    super();

    this.sliderDom = GetBy.class('__slider', this.container)[0];
    this.items = GetBy.selector('[scroll-infinity-item]', this.container);

    this.scroller = new InfiniteScroll(InfiniteScroll.AXIS_X, {
      domResize: this.sliderDom,
      container: this.sliderDom,
      // domControls: GetBy.class('__controls', this.container)[0],
      multiplicator: 1,
      itemClass: GallerySlider__Item,
      minSpeed: .4,
      inverted: false,
      gap: 0,
      hasVirtuaScroll: true
    });
    this.scroller.directGoto(Math.floor(this.items.length * .75));

    this.scrollMachine = new ScrollMachine(GetBy.class('__progress', this.container)[0]);
  }

  afterShow() {
    super.afterShow();

    this.scroller.show();
    this.scroller.start();
    this.scroller.goto(this.items.length);

    this.scrollMachine.show();
  }

  beforeHide() {
    super.beforeHide();
    this.scroller.hide();
    this.scroller.stop();

    this.scrollMachine.hide();
  }

  loop() {
    super.loop();
    this.scroller.loop();

    this.scrollMachine.loop(this.scroller.actual);
  }

  dispose() {
    this.scroller.dispose();
    this.scrollMachine.dispose();

    super.dispose();
  }

  resize(__w, __h) {
    super.resize(__w, __h);
    this.scroller.resize();
  }
}

ControllerPage._addPage('gallery', Gallery);

class GallerySlider__Item extends InfiniteScroll__Item {
  img = GetBy.selector("img", this.dom)[0];

  constructor(__d, __i, __axis = InfiniteScroll.AXIS_Y) {
    super(__d, __i, __axis, true);

    gsap.set(this.img, { filter: 'blur(10px)', opacity: 0 });
  }

  show() {
    super.show();

    gsap.to(this.img, { filter: 'blur(0px)', opacity: 1, duration: .8, ease: Power2.easeOut });
  }

  hide() {
    super.hide();

    gsap.to(this.img, { filter: 'blur(10px)', opacity: 0, duration: .3, ease: Power2.easeOut });
  }
}
